import { Pipe } from '@angular/core';

import { formatMediumDateTime, formatShortTime, formatMediumDate } from './DateFormatters';

@Pipe({ name: 'vbDateTimeMedium',
	standalone: false
})
export class VbDateTimeMediumPipe {
	public transform = formatMediumDateTime;
}

@Pipe({ name: 'vbDateMedium',
	standalone: false
})
export class VbDateMediumPipe {
	public transform = formatMediumDate;
}

@Pipe({ name: 'vbTimeShort',
	standalone: false
})
export class VbTimeShortPipe {
	public transform = formatShortTime;
}
